"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.VbzListCheckbox = void 0;
const react_1 = __importStar(require("react"));
const react_i18next_1 = require("react-i18next");
const reactstrap_1 = require("reactstrap");
const Checkbox_1 = require("../Checkbox");
exports.VbzListCheckbox = ({ list, placeholder = 'Select one', dark = false, dropdown, className, onChange, }) => {
    const [darkMode, setDarkMode] = react_1.useState('');
    const [isOpen, setIsOpen] = react_1.useState(false);
    const [label, setLabel] = react_1.useState('Select one');
    const { t } = react_i18next_1.useTranslation();
    const toggle = () => setIsOpen((prevState) => !prevState);
    const handleOnChange = (e) => {
        e.persist();
        onChange(e);
    };
    const handleClick = (e) => {
        e.preventDefault();
        setIsOpen((prev) => !prev);
    };
    react_1.useMemo(() => {
        setDarkMode(dark ? ' dark' : '');
    }, [dark]);
    react_1.useEffect(() => {
        if (placeholder) {
            setLabel(placeholder);
        }
    }, [placeholder]);
    return (react_1.default.createElement(react_1.default.Fragment, null, dropdown ? (react_1.default.createElement(reactstrap_1.Dropdown, { className: `input-group vbz-dropdown${darkMode} ${className}`, isOpen: isOpen, onClick: handleClick, toggle: toggle },
        react_1.default.createElement("div", { className: `dropdown-toggle vbz-dropdown-toggle${darkMode}` },
            react_1.default.createElement("span", { className: "vbz-placeholder" }, t(label)),
            react_1.default.createElement("i", { className: "material-icons" }, "expand_more")),
        react_1.default.createElement("ul", { className: `vbz-dropdown-chk${darkMode} ${dropdown ? ' dropdown-menu' : ''}` }, list.map((item) => (react_1.default.createElement("li", { key: item.value, className: `dropdown-item${darkMode}` },
            react_1.default.createElement(Checkbox_1.VbzCheckbox, { id: item.id, key: item.value, label: item.label, name: item.name, value: item.value, checked: item.checked, iconUndefined: item.iconUndefined, dark: dark, onChange: handleOnChange }))))))) : (react_1.default.createElement("ul", { className: `vbz-dropdown-chk${darkMode} ${className}` }, list.map((item) => (react_1.default.createElement("li", { key: item.value, className: `dropdown-item${darkMode}` },
        react_1.default.createElement(Checkbox_1.VbzCheckbox, { id: item.id, key: item.value, label: item.label, name: item.name, value: item.value, checked: item.checked, iconUndefined: item.iconUndefined, dark: dark, onChange: handleOnChange }))))))));
};
//# sourceMappingURL=index.js.map